import type { SelectOption } from '@atlassian/jira-common-components-picker/src/index.tsx';
import { requestVersions as restRequestVersions } from '../rest/index.tsx';
import { transformVersions } from './transformers.tsx';

type RequestVersions = (
	projectKey: string,
	filter: string,
	versionStatuses: string[],
	ignore: string[],
	excludeArchivedVersions?: boolean,
) => Promise<SelectOption[]>;

export const requestVersions: RequestVersions = async (
	projectKey,
	filter,
	versionStatuses,
	ignore,
	excludeArchivedVersions = false,
) => {
	const pageVersions = await restRequestVersions(projectKey, filter, versionStatuses, ignore);
	return transformVersions(pageVersions.values, ignore, excludeArchivedVersions);
};
